import { type Action, configureStore, type Dispatch, type ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { rootReducer } from 'reducers';
import { createMigrate, type MigrationManifest, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { translations } from 'translations';
import { migrations } from './persistMigrations';

function initStore() {
  const persistConfig = {
    key: 'ccp-store',
    version: 4,
    whitelist: ['settings', 'metadata'],
    storage,
    migrate: createMigrate(migrations as unknown as MigrationManifest),
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });

  const persistor = persistStore(store);

  return { store, persistor };
}

const initializer = initStore();
const { store } = initializer;

syncTranslationWithStore(store);

store.dispatch(loadTranslations(translations));
store.dispatch(setLocale('en-US'));

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = Dispatch<Action> & ThunkDispatch<RootState, null, Action>;
export const useAppDispatch: () => AppDispatch = useDispatch;

export const { persistor } = initializer;
export default store;
